module.exports = __webpack_public_path__ + "static/media/datasheet_entData_row1_picture.d6426761.png";